const MedicalCard = ({
  imgUrl,
  category = "category",
  description = "description",
}) => {
  return (
    <div className="flex flex-col items-center bg-white group  md:p-4 md:pt-12 cursor-pointer h-56 md:h-64 tab:h-[310px]">
      <div>
        <img src={imgUrl} className="h-24" alt="medical card icon" />
      </div>
      <div className="pt-3 font-medium text-primaryText text-5.5 md:text-2xl leading-7 text-center capitalize font-halyard">
        {category}
      </div>
      <div className="pt-1.5 font-normal leading-6  text-midGray text-md text-center capitalize font-dm-sans ">
        {description}
      </div>
      <div className="flex space-x-0.5 group-hover:text-green-500 text-[#CECECE] ">
        <div className="">
          <span className="font-bold text-3xl">.</span>
          <span className="font-bold text-3xl">.</span>
          <span className="font-bold text-3xl">.</span>
        </div>
      </div>
    </div>
  );
};

export default MedicalCard;
